// rem.ts 的优化版本
export function setupRem() {
	const baseSize = 75
	let lastWidth = window.innerWidth
	let timer = null

	function setRem() {
		// 获取当前屏幕方向
		const isLandscape = window.innerWidth > window.innerHeight
		// 如果是横屏，使用高度作为计算基准
		const baseWidth = isLandscape ? window.innerHeight : window.innerWidth
		const scale = baseWidth / 750
		const fontSize = baseSize * Math.min(scale, 2);
		console.log('fontSize-----',fontSize);
		document.documentElement.style.fontSize =  '37.5px';
	}

	// 添加防抖
	function debounceSetRem() {
		if (timer) {
			clearTimeout(timer)
		}
		timer = window.setTimeout(setRem, 100)
	}

	// 初始化
	setRem()

	// 添加防抖的 resize 监听
	window.addEventListener('resize', () => {
		// 只在宽度或高度变化时才重新计算
		if (lastWidth !== window.innerWidth) {
			lastWidth = window.innerWidth
			debounceSetRem()
		}
	})

	// 监听屏幕方向变化
	window.addEventListener('orientationchange', debounceSetRem)

	// 页面显示时重新计算
	window.addEventListener('pageshow', e => {
		if (e.persisted) {
			setRem()
		}
	})
}



// WEBPACK FOOTER //
// ./src/utils/rem.js